/**
 * Abort controllers for the global (explorer) search requests.
 *
 * Kept out of `SearchActions` so `ExplorerActions` can cancel a running search
 * without importing it - `SearchActions` already imports `ExplorerActions`, so
 * the reverse import would be a cycle. This module holds no Redux state.
 */
let searchController: AbortController | null = null
let aggregatedController: AbortController | null = null

/**
 * Starts a new main search request, aborting the previous one.
 * @returns The signal to pass to the search API call
 */
export const registerSearchRequest = (): AbortSignal => {
  searchController?.abort()
  searchController = new AbortController()
  return searchController.signal
}

/**
 * Starts a new aggregated (MDS) search request, aborting the previous one.
 * @returns The signal to pass to the search API call
 */
export const registerAggregatedSearchRequest = (): AbortSignal => {
  aggregatedController?.abort()
  aggregatedController = new AbortController()
  return aggregatedController.signal
}

/**
 * Aborts every search request in flight. Callers must also clear the search
 * state if the user is leaving the results behind - this only stops the
 * requests, so their late responses can no longer take over the screen.
 */
export const cancelSearchRequests = (): void => {
  searchController?.abort()
  searchController = null
  aggregatedController?.abort()
  aggregatedController = null
}
